export const i18n = {
  defaultLocale: 'en',
  locales: ['en', 'sr', 'si'],
} as const;

export type Locale = (typeof i18n)['locales'][number];

export function isLocale(value: string): value is Locale {
  return (i18n.locales as readonly string[]).includes(value);
}

export function withLocaleHref(href: string, locale: Locale | string): string {
  if (!href.startsWith('/')) return href;
  const seg1 = href.split('/')[1];
  if (seg1 && isLocale(seg1)) return href;
  return `/${locale}${href}`.replace(/\/{2,}/g, '/');
}
